import type { AdminAccount, ServiceHealth, ServiceHealthStatus } from '@/types/admin'
import { GET } from './helpers'

const baseServicesUrl = '/statuses/'

export const getAccountsForAdminPanel = async function () {
  return GET<AdminAccount[]>(`/admin-panel`, {}, {}, APP_ENV.VITE_APP_ACCOUNTS_HOST)
}

export const healthChecker = async function (service: string): Promise<ServiceHealthStatus> {
  const res = await GET<ServiceHealth>(
    `${baseServicesUrl}${service}`,
    {},
    {},
    APP_ENV.VITE_APP_SERVICES_HOST
  )
  if (res.ok) {
    const data = await res.json()
    return data.status
  } else {
    return 'error'
  }
}
